import { Selector } from '@ngxs/store';
import { CreateEventState, CreateEventStateModel } from './create-event.state';

export class CreateEventSelector {
  @Selector([CreateEventState])
  static loading(state: CreateEventStateModel): boolean {
    return state.loading;
  }

  @Selector([CreateEventState])
  static actualValues(state: CreateEventStateModel): CreateEventStateModel {
    return state;
  }

  @Selector([CreateEventState])
  static haveCompletedStepOne(state: CreateEventStateModel): boolean {
    return !!state.title && state.title !== '';
  }

  @Selector([CreateEventState])
  static sportIdSelected(state: CreateEventStateModel): string {
    return state.sportIdSelected;
  }

  @Selector([CreateEventState])
  /** Nothing until an activity has been created, which the state already said. */
  static eventIdCreated(state: CreateEventStateModel): string | undefined {
    return state.eventIdCreated;
  }

  @Selector([CreateEventState])
  static eventJustCreated(state: CreateEventStateModel): boolean {
    return state.eventJustCreated;
  }

  @Selector([CreateEventState])
  static groupName(state: CreateEventStateModel): string | undefined {
    return state.groupName;
  }
}
